import { Stakeholder } from "../user";
import { IConverter, TSnapshot } from "./generics";

export const stakeholderConverter: IConverter<Stakeholder> = {
  toFirestore(stakeholder: Stakeholder) {
    return stakeholder;
  },
  fromFirestore(snapshot: TSnapshot): Stakeholder {
    const data = snapshot.data();

    return {
      id: snapshot.id,
      firstName: data?.firstName,
      lastName: data?.lastName,
      email: data?.email,
      phone: data?.phone,
      role: data?.role,
      permissions: data?.permissions,
      documents: data?.documents || [],
      displayName: data?.displayName,
      needsOnboarding: data?.needsOnboarding,
      disabled: data?.disabled,
      disabledAt: data?.disabledAt,
      increaseExternalAccountProfile: {
        externalAccountId:
          data?.increaseExternalAccountProfile?.externalAccountId,
        externalAccountNickname:
          data?.increaseExternalAccountProfile?.externalAccountNickname,
        accountHolderFullName:
          data?.increaseExternalAccountProfile?.accountHolderFullName,
        accountHolderType:
          data?.increaseExternalAccountProfile?.accountHolderType,
        financialInstitution:
          data?.increaseExternalAccountProfile?.financialInstitution,
        achTransfersSupported:
          data?.increaseExternalAccountProfile?.achTransfersSupported,
        wireTransfersSupported:
          data?.increaseExternalAccountProfile?.wireTransfersSupported,
        realTimePaymentsSupported: data?.increaseRealTimePaymentsSupported,
        testPaymentFirestoreId:
          data?.increaseExternalAccountProfile?.testPaymentFirestoreId,
        testPaymentIncreaseId:
          data?.increaseExternalAccountProfile?.testPaymentIncreaseId,
        testPaymentExternalAccountId:
          data?.increaseExternalAccountProfile?.testPaymentExternalAccountId,
        testPaymentStatus:
          data?.increaseExternalAccountProfile?.testPaymentStatus,
        testPaymentCreatedAt:
          data?.increaseExternalAccountProfile?.testPaymentCreatedAt,
        testPaymentCompletedAt:
          data?.increaseExternalAccountProfile?.testPaymentCompletedAt,
        archivedExternalAccounts:
          data?.increaseExternalAccountProfile?.archivedExternalAccounts,
      },
      lastLoginAt: data?.lastLoginAt,
      lastPasswordResetRequestAt: data?.lastPasswordResetRequestAt,
      needsPasswordReset: data?.needsPasswordReset,
      passwordResetAt: data?.passwordResetAt,
      onboardingCompletedAt: data?.onboardingCompletedAt,
      createdAt: data?.createdAt,
      updatedAt: data?.updatedAt,
      needsInitialPasswordSet: data?.needsInitialPasswordSet,
      initialPasswordSetAt: data?.initialPasswordSetAt,
      lastVerificationEmailRequestAt: data?.lastVerificationEmailRequestAt,
      lastSignInLinkRequestAt: data?.lastSignInLinkRequestAt,
      paymentProfileCompleted: data?.paymentProfileCompleted,
      paymentProfileCompletedAt: data?.paymentProfileCompletedAt,
    };
  },
};
